/**
 * Persist the selected digest profile across LitCurrent apps.
 * Apps restore this on mount when the URL does not already specify a profile.
 */
const STORAGE_KEY = 'litpulse_selected_digest_profile_id';

export function getPersistedDigestProfileId(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw || raw === 'null' || raw === '__all__') return null;
    return raw;
  } catch {
    return null;
  }
}

export function setPersistedDigestProfileId(profileId: string | null): void {
  try {
    if (!profileId) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, profileId);
    }
  } catch {
    // ignore quota / private mode
  }
}

/** Pick a default digest: primary first, otherwise the first profile. */
export function pickDefaultDigestProfileId(
  profiles: Array<{ profile_id: string; is_primary?: boolean }>
): string | null {
  if (!profiles.length) return null;
  const primary = profiles.find((p) => p.is_primary);
  return (primary || profiles[0]).profile_id;
}
